<template>
  <div class="w-full bg-gray-100 flex items-center justify-center h-screen">
    <div
      class="
        w-79
        bg-white
        rounded
        border-t-4
        shadow
        border-orange-600
        flex flex-col
        items-center
        justify-center
      "
    >
      <el-form
        status-icon
        class="w-full px-5"
        :model="login"
        :rules="loginRules"
        ref="login"
        @submit.native.prevent="processLogin('login')"
      >
        <el-row :gutter="15" class="mt-10">
          <el-col :span="24" class="flex items-center justify-center">
            <img src="./../assets/imgs/logo.png" style="height: 50px" />
          </el-col>
        </el-row>
        <el-row :gutter="15" class="mt-5 mb-10">
          <el-col :span="24" class="flex items-center justify-center">
            <h2 class="uppercase text-orange-800 text-2xl">RECURSOS HUMANOS</h2>
          </el-col>
        </el-row>
        <el-row :gutter="15" class="mb-1">
          <el-col :span="24">
            <el-form-item prop="user">
              <el-input v-model="login.user" placeholder="Usuario" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15" class="mb-1">
          <el-col :span="24">
            <el-form-item prop="pass">
              <el-input
                type="password"
                v-model="login.pass"
                placeholder="Contraseña"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24" class="mb-5">
            <el-button
              type="primary"
              class="w-full"
              native-type="submit"
              :loading="logging"
              >Iniciar sesión</el-button
            >
          </el-col>
        </el-row>
        <el-row :gutter="15" v-if="loginMessage !== ''">
          <el-col :span="24" class="mb-10 text-center">
            <el-alert
              :title="loginMessage"
              :type="messageAccent(logginSuccess)"
              center
              :closable="false"
            />
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as R from "ramda";

export default {
  name: "Login",
  data() {
    return {
      logging: false,
      login: {
        user: "",
        pass: "",
      },
      loginRules: {
        user: [
          {
            required: true,
            message: "Debes completar este campo",
            trigger: "blur",
          },
        ],
        pass: [
          {
            required: true,
            message: "Debes completar este campo",
            trigger: "change",
          },
        ],
      },
      loginMessage: "",
      logginSuccess: false,
    };
  },
  methods: {
    processLogin(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        this.loginMessage = "";
        this.logging = true;
        const { user, pass } = this.login;
        axios
          .post("/", {
            query: `
            mutation {
              login(
                email: "${user}"
                password: "${pass}"
              ) {
                  token
                  user {
                    id
                    email
                    changePassword
                    isActive
                    avatarURL
                    super
                    names
                    lastnames
                    permissions
                  }
                }
            }`,
          })
          .then((res) => {
            const { data, errors } = res.data;
            if (!R.isNil(data)) {
              this.$store.commit("createSession", data.login);
              location.reload();
            } else {
              this.loginMessage = errors[0].message;
            }
          })
          .catch((err) => {
            this.$message.error(err.message);
          })
          .then((alw) => (this.logging = false));
      });
    },
    messageAccent(status) {
      if (status) {
        return "success";
      } else {
        return "error";
      }
    },
  },
};
</script>
